import { createAction } from "../fns/createAction";
import { fns } from "@holta/lib";
import { Supplier } from "@holta/lib/types";

export const setSuppliers = createAction("SET_SUPPLIERS", (newState, suppliers: Supplier[]) => {
    newState.suppliers = fns.shared.sortByString(suppliers, 'name', 'ASC');
});
